import {BrowserRouter} from 'react-router-dom';
import App from "../src/App";
import * as ReactDOM from 'react-dom/client';
import * as React from 'react';
import '@coreui/coreui-pro/dist/css/coreui.min.css'

const rootElement = document.getElementById('root');
if (!rootElement) {
    throw new Error("Could not find root element to mount to");
}

const root = ReactDOM.createRoot(rootElement);
root.render(
    <React.StrictMode>
        <BrowserRouter>
            <App/>
        </BrowserRouter>
    </React.StrictMode>
);